import React, { useState } from "react";
import "./Activities.css";

import { ActivityDescription } from "../../Sections/ActivityDescription/ActivityDescription";
import { activities } from "../../Pages/Activities/ActivitiesObject";

export const Activities = () => {
  const [selectedActivity, setSelectedActivity] = useState(activities[0]);

  const handleActivityClick = (activity) => {
    setSelectedActivity(activity);
  };

  return (
    <div
      className="activities-wrapper"
      style={{
        backgroundImage: `url(${selectedActivity.background})`,
      }}
    >
      <div className="activity-description">
        <ActivityDescription
          activities={activities}
          activity={selectedActivity}
          onActivityClick={handleActivityClick}
        />
      </div>
    </div>
  );
};
